import { ApiError } from "./api.js";

/**
 * Bledy pobierania raportu Word albo PDF (GET /api/sessions/:id/raport.docx | raport.pdf) jako zdania dla uzytkownika (S-1:
 * po ludzku, bez kodow). Kody odmow pochodza z src/routes/raportApi.ts.
 */
export function bladPobraniaRaportu(err: unknown, wariant: "administrator" | "uzytkownik" = "administrator"): string {
  if (!(err instanceof ApiError)) {
    return "Nie udało się pobrać raportu. Sprawdź połączenie i spróbuj ponownie.";
  }
  const uzytkownik = wariant === "uzytkownik";

  switch (err.code) {
    case "nie_ma_takiej_sesji":
      return uzytkownik ? "Nie ma już tej rozmowy. Wróć do listy rozmów." : "Nie ma już tej analizy. Wróć do listy analiz.";
    case "czeka_na_zatwierdzenie":
      return "Raport powstanie po zatwierdzeniu podziału tekstu i ocenie.";
    case "sesja_w_trakcie_przetwarzania":
      return "Analiza jest jeszcze przetwarzana. Raport będzie gotowy, gdy skończy się ocena.";
    case "brak_oceny":
      return "Nie ma jeszcze wyników oceny, więc nie ma czego pobrać.";
    case "raport_zajety":
      return "Inny raport jest teraz przygotowywany. Spróbuj ponownie za kilkanaście sekund.";
    case "raport_nieudany":
      return "Nie udało się przygotować pliku z raportem. Spróbuj ponownie za chwilę.";
    default:
      // Uzytkownik nie dostaje kodu w nawiasie (403 forbidden, 500 i inne): nic by mu nie powiedzial.
      return uzytkownik
        ? "Nie udało się pobrać raportu. Spróbuj ponownie za chwilę albo daj nam znać."
        : `Nie udało się pobrać raportu (${err.code}).`;
  }
}
